<template>
  <v-row class="pa-0 ma-0 mx-auto">
    <v-col class="pa-0 ma-0">
      <v-dialog v-model="showAdd" max-width="500px">
        <v-card style="width: 500px; overflow-x: hidden">
          <v-card-title class="card__title">{{
            titleForm ? "Editar" + addTitle : "Agregar" + addTitle
          }}</v-card-title>
          <v-alert
            dense
            v-if="error"
            color="red"
            elevation="5"
            outlined
            text
            type="error"
            align="center"
            class="mr-1 ml-1"
          >
            {{ alertValidate }}</v-alert
          >
          <v-form ref="form" v-model="valid">
            <date
              v-if="
                seeAction !== 'atributes' && seeAction !== 'accountBalances'
              "
              class="mb-4"
            />

            <div style="display: flex; flex-direction: column">
              <v-select
                dense
                v-if="seeAction == 'group'"
                outlined
                :label="nameAction"
                :items="getGroup"
                v-model="data.nameId"
                item-value="groupId"
                item-text="name"
                class="input__name"
                required
                :rules="rules"
                :disabled="titleForm"
              />
              <v-checkbox
                v-if="seeAction == 'group'"
                v-model="data.defaultGrp"
                class="input__name"
                label="Predeterminado"
              ></v-checkbox>

              <v-autocomplete
                dense
                v-if="seeAction == 'cards'"
                outlined
                :label="nameAction"
                :items="getCards"
                v-model="data.nameId"
                item-value="cardId"
                item-text="card"
                class="input__name"
                required
                :rules="rules"
                :disabled="titleForm"
              />
              <v-select
                dense
                v-if="seeAction == 'schedules'"
                class="input__name"
                required
                :rules="rules"
                :label="$tc('changeSchedule.schedule')"
                outlined
                v-model="data.nameId"
                :items="getSchedules"
                item-value="scheduleId"
                item-text="name"
                @change="changeSchedule"
                :disabled="titleForm"
              />
              <v-autocomplete
                dense
                v-if="seeAction == 'models'"
                outlined
                :label="nameAction"
                :items="getModels"
                v-model="data.nameId"
                item-value="liqmodelId"
                item-text="name"
                class="input__name"
                required
                :rules="rules"
                :disabled="titleForm"
              />
              <v-autocomplete
                dense
                v-if="seeAction == 'atributes'"
                outlined
                :label="nameAction"
                :items="
                  currentMode === 'add'
                    ? this.getFilterAtributes
                    : this.getAllAtributes
                "
                v-model="data.nameId"
                :disabled="titleForm"
                item-value="atribId"
                item-text="nameAndType"
                class="input__name"
                required
                :rules="rules"
                @change="changeType()"
              />
            </div>
            <div style="display: flex; justify-content: center">
              <v-text-field
                v-if="seeAction == 'atributes' && !showSelect"
                outlined
                label="Valor"
                class="input__name"
                v-model="data.value"
                dense
                :rules="rulesCase()"
              />
            </div>
            <v-select
              v-if="seeAction == 'atributes' && showSelect"
              v-model="data.value"
              :items="itemList"
              :label="$tc('attributes.labelLista')"
              outlined
              dense
              class="px-6"
              :rules="rulesCase()"
            />
            <div v-if="seeAction == 'schedules'">
              <v-select
                required
                :rules="rules"
                :label="$tc('changeSchedule.initialSegment')"
                dense
                outlined
                class="input__name"
                v-model="data.initialSegment"
                :items="getSegment"
                item-value="segmId"
                item-text="segment"
                @change="changeSegment"
                :no-data-text="$tc('changeSchedule.noSegment')"
              />
              <v-text-field
                dense
                class="input__name"
                required
                :rules="rules"
                :label="$tc('changeSchedule.initialDay')"
                outlined
                v-model="data.initialDay"
                :no-data-text="$tc('changeSchedule.noSequence')"
                type="number"
                :max="initialDay"
                :min="1"
              />
              <v-select
                dense
                class="input__name"
                required
                :rules="rules"
                :label="$tc('changeSchedule.sequenceNumber')"
                outlined
                :items="getNumSequence"
                item-value="id"
                item-text="id"
                :no-data-text="$tc('changeSchedule.noSequence')"
                v-model="data.sequenceNumber"
              />
            </div>
            <div v-if="seeAction == 'assignWatches'">
              <v-select
                dense
                class="input__name"
                required
                :rules="rules"
                :label="$tc('assignWatches.add')"
                outlined
                :items="filterForWatches"
                item-value="relojId"
                item-text="nombre"
                v-model="selectWatch"
                :multiple="true"
                :readonly="readOnly"
              />
            </div>
            <div v-if="seeAction == 'pattern'">
              <v-select
                dense
                multiple
                v-model="data.pattern"
                label="Elementos"
                required
                :rules="rules"
                :items="pattern"
                item-value="id"
                item-text="name"
                attach
                chips
                outlined
                class="input__name"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index <= 3" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 4" class="grey--text text-caption">
                    (+ {{ data.pattern.length - 4 }} )
                  </span>
                </template>
              </v-select>
              <div
                style="border: 1px solid #959595; height: 60px"
                class="input__name"
              >
                <v-slider
                  v-model="data.tolerance"
                  max="100"
                  thumb-label="always"
                  :label="$tc('changeTimePattern.tolerance')"
                  class="mr-1 ml-1 slider mt-3"
                  thumb-size="20"
                />
              </div>
              <v-select
                dense
                required
                :rules="rules"
                v-model="costs"
                :items="getCost"
                item-value="id"
                item-text="name"
                :label="$tc('changeTimePattern.cost')"
                outlined
                class="input__name mt-10"
                style="height: 75px"
              />
              <v-select
                dense
                required
                :rules="rules"
                v-model="data.autoriz"
                :label="$tc('changeTimePattern.autoriz')"
                outlined
                :items="autoriz"
                item-value="value"
                item-text="name"
                class="input__name"
              />
            </div>
            <div v-if="seeAction == 'accountBalances'">
              <v-select
                dense
                outlined
                :rules="rules"
                label="Aplica en"
                class="input__name"
                :items="optionsApplies"
                item-value="value"
                item-text="name"
                v-model="data.appliesIn"
              />
              <v-autocomplete
                dense
                required
                :rules="rules"
                v-model="data.selectedConceptIds"
                :items="getConcepts"
                item-value="conceptId"
                item-text="name"
                :label="$tc('concepts.concepts')"
                :disabled="titleForm"
                multiple
                outlined
                class="input__name"
              />
            </div>
          </v-form>
          <div class="d-flex justify-space-between mx-6 mb-4 mt-2">
            <v-btn class="bt-exit" @click="cancel">
              {{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="goTo">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <!---------------------------------------DELETE----------------------------------------->
      <v-dialog v-model="showDelete" max-width="450px">
        <v-card max-width="450px">
          <v-card-title style="display: flex; justify-content: center">{{
            deleteTitle
          }}</v-card-title>
          <div style="display: flex; justify-content: center">
            <v-btn class="bt-exit mr-2 mb-2" @click="showDelete = false">
              {{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="deleteAction">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <!--------------------------------------------------------------------------------------->
      <!---------------------------------------MOVEMENTS----------------------------------------->
      <v-dialog v-model="showMovements" max-width="750px">
        <v-card max-width="750px">
          <v-card-title style="display: flex; justify-content: center">{{
            dialogTitleBalance
          }}</v-card-title>
          <v-card-text>
            <div class="primary">
              <v-text-field
                dense
                solo
                max-width="500px"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$tc('commons.search')"
                single-line
                hide-details
                class="search my-auto mx-auto py-1"
              />

              <v-data-table
                :headers="headersBalances"
                :items="filteredBalances"
                :search="search"
                class="elevation-1"
                style="height: 400px"
                disable-pagination
                hide-default-footer
              ></v-data-table>
            </div>
          </v-card-text>
          <v-card-actions style="display: flex; justify-content: center">
            <v-btn class="bt-exit mr-2 mb-2" @click="showMovements = false">
              {{ $tc("editRegistrations.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--------------------------------------------------------------------------------------->
      <!---------------------------------------ADD ----------------------------------------->
      <v-dialog v-model="showBalances" max-width="450px">
        <v-card max-width="450px">
          <v-card-title style="display: flex; justify-content: center">{{
            "Agregar movimiento"
          }}</v-card-title>
          <v-card-text>
            <v-autocomplete
              ref="autocomplete"
              dense
              required
              :rules="rules"
              v-model="dataAddMovim.conceptId"
              :items="getAllConcepts"
              item-value="conceptId"
              item-text="name"
              :label="$tc('concepts.concepts')"
              readonly
              outlined
            />
            <v-text-field
              ref="amount"
              dense
              outlined
              v-model="dataAddMovim.amount"
              type="number"
              label="Cantidad"
              required
              :rules="rules"
            ></v-text-field>
            <div class="d-flex justify-space-between mx-1">
              <v-btn class="bt-exit" @click="cancelMovements">
                {{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn class="bt-acept" @click="addMovim">
                {{ $tc("editRegistrations.acept") }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--------------------------------------------------------------------------------------->

      <DataTableEmp
        :items="items"
        :headers="headers"
        :openEdit="openEdit"
        :openDelete="openDelete"
        :openAdd="openAdd"
        :showSeeDetails="this.showBtns.showSeeDetails"
        :showAdd="this.showBtns.showAdd"
        :showEdit="this.showBtns.showEdit"
        :openAccountMovements="openMovements"
        :openAddInitialBalance="openBalances"
        :saveConfigColums="this.saveConfigColums"
        @refreshItems="refreshItems"
        :asegurable="asegurable"
      />
    </v-col>

    <Alerts :alert="errorAlert" :color="colorError" :textAlert="textAlertOk" />
    <Alerts :alert="ok" :color="colorOk" :textAlert="textAlertOk" />
  </v-row>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import Date from "../commons/Date.vue";
import DataTableEmp from "./DataTableEmp.vue";
import moment from "moment";
import Alerts from "../commons/Alerts.vue";
import registrations from "../../../store/gestionTiempos/registrations";
import changeTimePattern from "../../../store/gestionTiempos/changeTimePattern";
import concepts from "@/store/conceptos/concepts";

export default {
  components: {
    DataTableEmp,
    Alerts,
    Date,
    AgGridVue,
  },
  props: {
    asegurable: String,
    items: Array,
    headers: Array,
    addTitle: String,
    nameAction: String,
    deleteTitle: String,
    saveConfigColums: Function,
  },
  data() {
    return {
      itemList: null,
      showSelect: false,
      AG_GRID_LOCALE_ES: {
        selectAll: "(Seleccionar todo)",
        selectAllSearchResults:
          "(Seleccionar todos los resultados de búsqueda)",
        addCurrentSelectionToFilter: "Agregar selección actual al filtro",
        searchOoo: "Buscar...",
        blanks: "(En blanco)",
        noMatches: "Sin coincidencias",
        filterOoo: "Filtrar...",
        equals: "Igual",
        notEqual: "No igual",
        blank: "Vacio",
        notBlank: "No vacio",
        empty: "Elija uno",
        lessThan: "Menor que",
        greaterThan: "Mayor que",
        lessThanOrEqual: "Menor o igual que",
        greaterThanOrEqual: "Mayor o igual que",
        inRange: "Entre",
        inRangeStart: "Desde",
        inRangeEnd: "Hasta",
        contains: "Contiene",
        notContains: "No contiene",
        startsWith: "Comienza con",
        endsWith: "Termina con",
        dateFormatOoo: "yyyy-mm-dd",
        before: "Antes de",
        after: "Después de",
        andCondition: "Y",
        orCondition: "O",
      },
      dataAddMovim: {
        conceptId: null,
        amount: null,
      },
      pattern: [
        { name: "Liq. Horas", id: 0, ingles: "liqhs" },
        { name: "Tarde", id: 1, ingles: "late" },
        { name: "Ret.Anticipado", id: 2, ingles: "retAnt" },
        { name: "Lic. Parcial", id: 3, ingles: "licPar" },
        { name: "Lic.Total", id: 4, ingles: "licTot" },
        { name: "Caídas", id: 5, ingles: "falls" },
      ],
      loading: false,
      showAdd: false,
      showBalances: false,
      showMovements: false,
      titleForm: false,
      showDelete: false,
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      textAlertOk: "",
      action: null,
      seeAction: "",
      errorAlert: false,
      ok: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      from: false,
      error: false,
      alertValidate: "",
      to: false,
      valid: true,
      data: {
        from: null,
        to: null,
        nameId: null,
        value: null,
        initialSegment: null,
        initialDay: 1,
        sequenceNumber: null,
        pattern: [0, 1, 2, 3, 4, 5],
        tolerance: 0,
        cost: null,
        autoriz: "D",
        appliesIn: "WF",
        selectedConceptIds: [],
        defaultGrp: false,
      },
      currentMode: "",
      deleteItems: {},
      editItems: {},
      initialDay: null,
      optionsApplies: [
        { name: "Flujo de trabajo", value: "WF" },
        { name: "Liquidación", value: "LI" },
      ],
      autoriz: [
        { name: "Siempre", value: "T" },
        { name: "Nunca", value: "N" },
        { name: "Predeterminado", value: "D" },
      ],
      checkTo: this.$store.state.employees.checkTo,
      showBtns: { showAdd: false, showSeeDetails: false, showEdit: true },
      balances: [],
      columns: [],
      showColumnMenu: false,
      columnFilter: "",
      search: "",
      headersBalances: [
        {
          text: "Fecha",
          value: "date",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Operador",
          value: "nameOper",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Cantidad",
          value: "amount",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Saldo",
          value: "balance",
          class: "primary secondary--text",
          visible: true,
        },
      ],
      gridOptions: {
        defaultColDef: {
          suppressDragLeaveHidesColumns: false,
          sortable: true,
          resizable: true,
          filter: true,
        },
      },
      selectWatch: null,
      readOnly: false,
    };
  },

  mounted() {
    this.$store.dispatch("assignWatches/getWatches");
    this.$store.dispatch("atributes/getAllAtributes");
    this.selectedColumns = this.headersBalances.map((column) => column.field);
    let route = this.$route.path;
    this.action = route.split("/", 5);
    this.showBtns =
      this.action[4] === "Saldos"
        ? { showAdd: true, showSeeDetails: true, showEdit: false }
        : { showAdd: false, showSeeDetails: false, showEdit: true };
  },
  computed: {
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.headersBalances.filter((column) => {
        return column.text.toLowerCase().includes(filterText);
      });
    },
    visibleHeaders() {
      return this.headersBalances.filter((column) => column.visible);
    },
    filteredBalances() {
      return this.balances.filter((balance) => {
        const searchableFields = Object.values(balance).join("").toLowerCase();
        return searchableFields.includes(this.search.toLowerCase());
      });
    },
    dialogTitleBalance() {
      if (this.balances.length > 0) {
        return `Movimientos de la cuenta ${this.balances[0].nameConcept}`;
      } else {
        return "Movimientos de la cuenta";
      }
    },
    employed: {
      get() {
        return this.$store.state.employees.itemsEmployed;
      },
      set(newValue) {
        return newValue;
      },
    },
    getCost() {
      return registrations.state.csCosts;
    },
    getAllConcepts() {
      return concepts.state.concepts;
    },
    getConcepts() {
      const allConcepts = concepts.state.concepts;
      const filteredConcepts = allConcepts.filter((concept) => {
        return concept.fullDayLicense === "S" && concept.workHours === "N";
      });

      if (this.currentMode === "edit") {
        return filteredConcepts;
      } else if (this.currentMode === "add") {
        const filteredConcepts = concepts.state.concepts.filter((concept) => {
          return concept.fullDayLicense === "S" && concept.workHours === "N";
        });

        const excludedConcepts =
          this.$store.state.accountBalances.accountBalances.map(
            (balance) => balance.conceptId,
          );
        const availableConcepts = filteredConcepts.filter((concept) => {
          return !excludedConcepts.includes(concept.id);
        });
        return availableConcepts;
      } else {
        return [];
      }
    },
    getTimePattern() {
      return changeTimePattern.state.timePattern.item;
    },
    costs: {
      get() {
        this.data.cost = registrations.state.csCosts[0]
          ? registrations.state.csCosts[0].id
          : null;
        return registrations.state.csCosts[0]
          ? registrations.state.csCosts[0].id
          : null;
      },
      set(val) {},
    },
    getSegment() {
      return this.$store.state.changeSchedule.segment;
    },
    getNumSequence() {
      return this.$store.state.changeSchedule.numsequence;
    },
    getGroup() {
      return this.$store.state.changeGroup.group.item;
    },
    getCards() {
      if (this.currentMode === "add") {
        return this.$store.state.assignCards.cardAssign;
      } else {
        return this.$store.state.assignCards.cards;
      }
    },
    getSchedules() {
      return this.$store.state.changeSchedule.schedule;
    },
    getModels() {
      return this.$store.state.gestionTiempos.models;
    },
    getAllAtributes() {
      return this.$store.state.atributes.allAtributes;
    },
    getFilterAtributes() {
      const atribIdsToExclude = this.items.map((item) => item.atribId);
      const filteredAtributes = this.$store.state.atributes.allAtributes.filter(
        (atrib) => !atribIdsToExclude.includes(atrib.atribId),
      );
      return filteredAtributes;
    },

    filterForWatches() {
      if (this.currentMode === "edit") {
        this.readOnly = true;
        return this.$store.state.assignWatches.watch;
      } else {
        this.readOnly = false;
        this.selectWatch = null;
        const watchArray = this.$store.state.assignWatches.watch || [];
        const watchesAsignArray =
          this.$store.state.assignWatches.watchesAsign || [];
        if (!Array.isArray(watchArray) || !Array.isArray(watchesAsignArray)) {
          console.error("Error: Uno de los arrays no es válido.");
          return [];
        }
        return watchArray
          .filter(
            (watch) =>
              !watchesAsignArray.some(
                (assign) => assign.relojId === watch.relojId,
              ),
          )
          .map((watch) => ({
            nombre: watch.nombre,
            relojId: watch.relojId,
            descripcion: watch.descripcion,
          }));
      }
    },
  },
  methods: {
    rulesCase() {
      let atribute = this.$store.state.atributes.allAtributes.find(
        (itemAtribute) => {
          return itemAtribute.atribId == this.data.nameId;
        },
      );
      if (!atribute) {
        return [];
      }
      switch (atribute.type) {
        case "Entero":
          return [
            (v) => !isNaN(v) || this.$tc("attributes.mustBeNumber"),
            (v) =>
              (v >= -100000 && v <= 1000000) ||
              this.$tc("attributes.numberRange"),
          ];
        case "Cadena":
          return [
            (v) =>
              (typeof v === "string" && v.length <= 120) ||
              this.$tc("attributes.maxLength"),
          ];
        case "Lista":
          return [(v) => !!v || this.$tc("editRegistrations.required")];
        default:
          return [];
      }
    },
    changeType() {
      let atribute = this.$store.state.atributes.allAtributes.find(
        (itemAtribute) => {
          return itemAtribute.atribId == this.data.nameId;
        },
      );

      if (!atribute) {
        console.warn("Atributo no encontrado");
        return;
      }
      switch (atribute.type) {
        case "Entero":
          this.itemList = [];
          this.showSelect = false;
          break;
        case "Cadena":
          this.itemList = [];
          this.showSelect = false;
          break;
        case "Lista":
          this.itemList = atribute.values ? atribute.values.split(",") : [];
          this.showSelect = true;
          return [(v) => !!v || this.$tc("editRegistrations.required")];
      }
    },
    toggleColumnMenu() {
      this.showColumnMenu = !this.showColumnMenu;
    },
    goTo() {
      if (this.titleForm) {
        this.editValidate();
      } else {
        this.validate();
      }
    },
    async refreshItems() {
      switch (this.action[4]) {
        case "Pautas":
          await changeTimePattern.dispatch("getTimePattern");
          break;
        case "Grupos":
          await this.$store.dispatch("changeGroup/getGroupsAssigned");
          break;
        case "Horarios":
          await this.$store.dispatch("changeSchedule/getEmployedSchedule");
          break;
        case "Modelos":
          await this.$store.dispatch("changeSettlementModel/getModelEmployed");
          break;
        case "Atributos":
          await this.$store.dispatch("atributes/getAtributes");
          break;
        case "Tarjetas":
          await this.$store.dispatch("assignCards/getCards");
          break;
        case "Saldos":
          await this.$store.dispatch("accountBalances/getAccountBalances");
          break;
        case "Relojes":
          await this.$store.dispatch("assignWatches/getWatchesAsign");
          break;
        default:
          break;
      }
    },
    openAdd() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.currentMode = "add";
      this.showAdd = true;
      this.titleForm = false;

      this.defaultData();
      switch (this.action[4]) {
        case "Grupos":
          this.seeAction = "group";
          this.$store.dispatch("changeGroup/getGroups");
          break;
        case "Pautas":
          this.seeAction = "pattern";
          changeTimePattern.dispatch("getTimePattern");
          registrations.dispatch("getCsCost");
          break;
        case "Horarios":
          this.seeAction = "schedules";
          this.$store.dispatch("changeSchedule/getSchedules");
          break;
        case "Modelos":
          this.seeAction = "models";
          this.$store.dispatch("gestionTiempos/getModels");
          break;
        case "Atributos":
          this.seeAction = "atributes";
          this.$store.dispatch("atributes/getAllAtributes");
          break;
        case "Tarjetas":
          this.seeAction = "cards";
          this.$store.dispatch("assignCards/getCardsAssign");
          break;
        case "Saldos":
          this.seeAction = "accountBalances";
          concepts.dispatch("getConcepts");
          break;
        case "Relojes":
          this.seeAction = "assignWatches";
          this.$store.dispatch("assignWatches/getWatches");
          break;
        default:
          break;
      }
    },
    openMovements(item) {
      this.loading = true;
      this.$store
        .dispatch("accountBalances/getAccountBalanceHistory", item)
        .then(() => {
          this.balances =
            this.$store.state.accountBalances.accountBalanceHistory;

          this.showMovements = true;
          this.loading = false;
        });
    },
    openBalances(item) {
      concepts.dispatch("getConcepts");
      this.$store.commit("accountBalances/setNew", item);
      this.showBalances = true;
      this.dataAddMovim.conceptId = item.conceptId;
    },
    addMovim() {
      this.$store.state.accountBalances.new.amount = parseFloat(
        this.dataAddMovim.amount,
      );
      this.$store.state.accountBalances.new.conceptId =
        this.dataAddMovim.conceptId;
      this.$store
        .dispatch("accountBalances/newMovim")
        .then(() => {
          this.showBalances = false;
          this.ok = true;

          this.textAlertOk = "Se agrego correctamente el saldo inicial";
          this.cancelMovements();
        })
        .catch((e) => {
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
    },
    validate() {
      let valid = this.$refs.form.validate();
      if (this.$store.state.employees.checkTo) {
        this.data.to = null;
      }

      if (valid) {
        this.add();
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    add() {
      let payload;
      switch (this.action[4]) {
        case "Grupos":
          payload = {
            group: this.data.nameId,
            from: this.$store.state.employees.dateFrom,
            to: this.$store.state.employees.dateTo,
            defaultGrp: this.data.defaultGrp == true ? "S" : "N",
          };

          this.$store.commit("changeGroup/setNew", payload);
          this.$store
            .dispatch("changeGroup/newGroup")
            .then(() => {
              this.$store.dispatch("changeGroup/getGroupsAssigned");
              this.ok = true;
              this.textAlertOk = "El grupo se agrego correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Pautas":
          let newPattern = this.data.pattern;
          let items = this.patternFunction(newPattern);
          changeTimePattern.commit("setNew", items);
          changeTimePattern
            .dispatch("newTimePattern")
            .then((r) => {
              this.textAlertOk = this.$tc("changeTimePattern.alertOk");
              this.ok = true;
              changeTimePattern.dispatch("getTimePattern");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Horarios":
          payload = {
            schedule: this.data.nameId,
            from: this.$store.state.employees.dateFrom,
            to: this.$store.state.employees.dateTo,
            date: moment().format("YYYY-MM-DD"),
            initialSegment: this.data.initialSegment,
            sequenceNumber: this.data.sequenceNumber,
          };
          if (typeof this.data.initialDay === "string") {
            payload.initialDay = Number(this.data.initialDay);
          } else {
            payload.initialDay = this.data.initialDay;
          }
          this.$store.commit("changeSchedule/setNew", payload);
          this.$store
            .dispatch("changeSchedule/getChangeSchedule")
            .then(() => {
              this.$store.dispatch("changeSchedule/getEmployedSchedule");

              this.ok = true;
              this.textAlertOk = "El horario se agrego correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Modelos":
          payload = {
            model: this.data.nameId,
            from: this.$store.state.employees.dateFrom,
            to: this.$store.state.employees.dateTo,
            date: moment().format("YYYY-MM-DD"),
          };
          this.$store.commit("changeSettlementModel/setNew", payload);
          this.$store
            .dispatch("changeSettlementModel/newSettlementModel")
            .then(() => {
              this.$store.dispatch("changeSettlementModel/getModelEmployed");

              this.ok = true;
              this.textAlertOk = "El modelo se agrego correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Atributos":
          let atribute = this.$store.state.atributes.allAtributes.filter(
            (item) => {
              return item.atribId == this.data.nameId;
            },
          )[0];
          payload = {
            atribNombre: atribute.name,
            atribId: this.data.nameId,
            valor: this.data.value,
          };

          this.$store.commit("atributes/setNew", payload);
          this.$store
            .dispatch("atributes/newAtribute")
            .then(() => {
              this.$store.dispatch("atributes/getAtributes");

              this.ok = true;
              this.textAlertOk = "El atributo se agrego correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Tarjetas":
          payload = {
            cardId: this.data.nameId,
            from: this.$store.state.employees.dateFrom,
            to: this.$store.state.employees.dateTo,
            date: moment().format("YYYY-MM-DD"),
          };

          this.$store.commit("assignCards/setNew", payload);
          this.$store
            .dispatch("assignCards/newCard")
            .then(() => {
              this.$store.dispatch("assignCards/getCards");
              this.ok = true;
              this.textAlertOk = "Se agrego correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.data.error.message;
            });

          break;
        case "Saldos":
          payload = {
            appliesIn: this.data.appliesIn,
            concepts: this.data.selectedConceptIds,
          };

          this.$store.commit("accountBalances/setNew", payload);
          this.$store
            .dispatch("accountBalances/new")
            .then(() => {
              this.$store.dispatch("accountBalances/getAccountBalances");
              this.ok = true;
              this.textAlertOk = "Se agrego correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = "Error";
            });
          break;
        case "Relojes":
          payload = {
            relojes: this.selectWatch,
            from: this.$store.state.employees.dateFrom,
          };
          if (this.$store.state.employees.dateTo) {
            payload.to = this.$store.state.employees.dateTo;
          }

          this.$store.commit("assignWatches/setNew", payload);
          this.$store
            .dispatch("assignWatches/newWatch")
            .then(() => {
              this.selectWatch = null;
              this.ok = true;
              this.textAlertOk = "Se agrego correctamente";
            })
            .catch((e) => {
              console.log(e);
              this.errorAlert = true;
              this.textAlertOk = "Error";
            });
          break;
        default:
          break;
      }
      this.showAdd = false;
      this.defaultData();
    },

    openDelete(item) {
      this.showDelete = true;
      this.deleteItems = item;
    },

    deleteAction() {
      let payload;
      let from;
      if (this.deleteItems.from) {
        from = this.deleteItems.from
          .slice(0, 10)
          .split(/\D/)
          .reverse()
          .join("-");
      }
      switch (this.action[4]) {
        case "Grupos":
          payload = {
            from: from,
            id: this.deleteItems.grupId,
          };
          this.$store.commit("changeGroup/setDeleteItem", payload);
          this.$store
            .dispatch("changeGroup/delete")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
              this.$store.dispatch("changeGroup/getGroupsAssigned");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });
          this.showDelete = false;
          break;
        case "Pautas":
          payload = {
            from: from,
          };
          changeTimePattern.commit("setDeleteItem", payload);
          changeTimePattern
            .dispatch("delete")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
              changeTimePattern.dispatch("getTimePattern");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          this.showDelete = false;
          break;
        case "Horarios":
          payload = {
            from: from,
            id: this.deleteItems.scheduleId,
          };
          this.$store.commit("changeSchedule/setDeleteItem", payload);
          this.$store
            .dispatch("changeSchedule/delete")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
              this.$store.dispatch("changeSchedule/getEmployedSchedule");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          this.showDelete = false;
          break;
        case "Modelos":
          payload = {
            from: from,
            id: this.deleteItems.modelId,
          };
          this.$store.commit("changeSettlementModel/setDeleteItem", payload);
          this.$store
            .dispatch("changeSettlementModel/delete")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
              this.$store.dispatch("changeSettlementModel/getModelEmployed");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          this.showDelete = false;

          break;
        case "Atributos":
          payload = {
            id: this.deleteItems.atribId,
          };
          this.$store.commit("atributes/setDeleteItem", payload);
          this.$store
            .dispatch("atributes/delete")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
              this.$store.dispatch("atributes/getAtributes");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          this.showDelete = false;

          break;
        case "Tarjetas":
          payload = {
            fecDesde: from,
            tarjId: this.deleteItems.cardId,
          };
          this.$store.commit("assignCards/setDeleteItem", payload);
          this.$store
            .dispatch("assignCards/deleteCard")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
              this.$store.dispatch("assignCards/getCards");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });
          this.showDelete = false;
          break;
        case "Saldos":
          payload = {
            conceptoId: this.deleteItems.conceptId,
          };
          this.$store.commit("accountBalances/setDeleteItem", payload);
          this.$store
            .dispatch("accountBalances/delete")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
              this.$store.dispatch("accountBalances/getAccountBalances");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          this.showDelete = false;
          break;
        case "Relojes":
          payload = {
            empId: this.deleteItems.empId,
            relojId: this.deleteItems.relojId,
            fecDesde: this.deleteItems.from
              .slice(0, 10)
              .split(/\D/)
              .reverse()
              .join("-"),
          };
          this.$store.commit("assignWatches/setDeleteItem", payload);
          this.$store
            .dispatch("assignWatches/deleteWatch")
            .then(() => {
              this.ok = true;
              this.textAlertOk = this.$tc("gestionEmpleados.delete");
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });
          this.showDelete = false;
          break;
        default:
          break;
      }
    },

    async openEdit(item) {
      this.currentMode = "edit";
      let from;
      let to;
      if (this.action[4] !== "Atributos" && this.action[4] !== "Saldos") {
        from = item.from.slice(0, 10).split(/\D/).reverse().join("-");
        to =
          item.to !== " "
            ? item.to.slice(0, 10).split(/\D/).reverse().join("-")
            : null;
        this.checkTo = item.to == " " ? true : false;
        this.$store.commit("employees/setCheckTo", this.checkTo);
        this.$store.commit("employees/setDateTo", to);
        this.$store.commit("employees/setDateFrom", from);
      }

      if ((item.from && item.name) || item.card) {
        this.editItems = {
          from: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
          to: to,
          name: item.name == undefined ? item.card.trim() : item.name,
        };
      } else if (item.from && !item.name) {
        this.editItems = {
          from: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
          to: to,
        };
      } else {
        this.editItems = {
          name: item.name == undefined ? item.atribName.trim() : item.name,
        };
      }

      switch (this.action[4]) {
        case "Grupos":
          await this.$store.dispatch("changeGroup/getGroups").then(() => {
            this.seeAction = "group";

            this.data = {
              from: this.$store.state.employees.dateFrom,
              to: this.$store.state.employees.dateTo,
              fromOld: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
              nameId: item.grupId,
              defaultGrp: item.defaultGrp == "✔️" ? true : false,
            };

            this.editItems = {
              ...this.editItems,
              nameId: item.grupId,
            };
          });

          break;
        case "Pautas":
          await registrations.dispatch("getCsCost").then(() => {
            this.seeAction = "pattern";
          });

          let newPatterObject = [];

          Object.entries(item).forEach(([key, value]) => {
            if (value == "✔️") {
              let filteredItems = this.pattern.filter((e) => e.ingles == key);
              newPatterObject.push(...filteredItems);
            }
          });

          let newArrayPattern = newPatterObject.map((e) => e.id);

          const auto = this.autoriz.filter((e) => e.name == item.autorizLiq);

          this.data = {
            from: this.$store.state.employees.dateFrom,
            to: this.$store.state.employees.dateTo,
            fromOld: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
            autoriz: auto[0].value,
            pattern: newArrayPattern,
            cost: item.hCaiCsCostoId,
            tolerance: item.hCaiTol,
          };

          this.editItems = {
            ...this.editItems,
            pattern: newArrayPattern,
            autoriz: item.autorizLiq,
            cost: item.hCaiCsCostoId,
            tolerance: item.hCaiTol,
          };

          break;
        case "Horarios":
          await this.$store.commit(
            "changeSchedule/setScheduleId",
            item.scheduleId,
          );
          await this.$store.commit("changeSchedule/setSegmId", item.segmId);
          await this.$store.dispatch("changeSchedule/getSequence");
          await this.$store.dispatch("changeSchedule/getSegment").then(() => {
            this.initialDay = this.initialDays(item.segmId);
          });

          await this.$store.dispatch("changeSchedule/getSchedules").then(() => {
            this.seeAction = "schedules";
            this.data = {
              from: this.$store.state.employees.dateFrom,
              to: this.$store.state.employees.dateTo,
              fromOld: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
              nameId: item.scheduleId,
              initialSegment: item.segmId,
              sequenceNumber: item.numSecuencia,
              haNoEx: this.$store.state.employees.checkTo,
            };
            if (typeof item.segmDespl === "string") {
              this.data.initialDay = Number(item.segmDespl);
            } else {
              this.data.initialDay = item.segmDespl;
            }
            this.editItems = {
              ...this.editItems,
              nameId: item.scheduleId,
            };
            this.$store.commit(
              "changeSchedule/setScheduleId",
              this.data.nameId,
            );
          });

          break;
        case "Modelos":
          await this.$store.dispatch("gestionTiempos/getModels").then(() => {
            this.seeAction = "models";
            this.data = {
              from: this.$store.state.employees.dateFrom,
              to: this.$store.state.employees.dateTo,
              fromOld: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
              nameId: item.modelId,
            };

            this.editItems = {
              ...this.editItems,
              nameId: item.modelId,
            };
          });

          break;
        case "Atributos":
          await this.$store.dispatch("atributes/getAllAtributes").then(() => {
            this.seeAction = "atributes";
            this.data = {
              nameId: item.atribId,
              value: item.value,
            };
            this.editItems = {
              ...this.editItems,
              nameId: item.atribId,
            };
            this.changeType();
          });
          break;
        case "Tarjetas":
          await this.$store.dispatch("assignCards/getCards").then(() => {
            this.seeAction = "cards";
            this.data = {
              nameId: item.cardId,
              from: this.$store.state.employees.dateFrom,
              to: this.$store.state.employees.dateTo,
              fromOld: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
            };
            this.editItems = {
              ...this.editItems,
              nameId: item.cardId,
            };
          });
          break;
        case "Saldos":
          await concepts.dispatch("getConcepts").then(() => {
            this.seeAction = "accountBalances";
            this.data = {
              amount: item.amount,
              selectedConceptIds: item.conceptId,
            };
            this.editItems = {
              ...this.editItems,
              nameId: item.conceptId,
            };
          });
          break;
        case "Relojes":
          this.seeAction = "assignWatches";
          this.selectWatch = item.relojId;

          this.editItems = {
            ...this.editItems,
            relojId: item.relojId,
          };
          break;
        default:
          break;
      }
      this.showAdd = true;
      this.titleForm = true;
    },

    editValidate() {
      let valid = this.$refs.form.validate();
      let payload;
      if (this.$store.state.employees.checkTo) {
        this.$store.commit("employees/setDateTo", null);
      }

      if (this.action[4] == "Pautas") {
        payload = {
          fromOld: this.editItems.from,
          autoriz: this.data.autoriz,
          cost: this.data.cost,
          tolerance: this.data.tolerance,
          from: this.$store.state.employees.dateFrom,
          to: this.$store.state.employees.dateTo,
          haNoEx: this.$store.state.employees.checkTo,
        };
      } else if (this.action[4] == "Saldos") {
        payload = {
          amount: this.data.amount,
          conceptId: this.data.selectedConceptIds,
        };
      } else if (this.action[4] == "Relojes") {
        payload = {
          relojId: this.editItems.relojId,
          oldFrom: this.editItems.from,
          haNoEx: false,
        };
        if (this.$store.state.employees.dateFrom !== this.editItems.from) {
          payload.from = this.$store.state.employees.dateFrom;
        }
        if (
          this.$store.state.employees.dateTo !== this.editItems.to &&
          this.editItems.to !== " " &&
          this.$store.state.employees.dateTo !== null
        ) {
          payload.to = this.$store.state.employees.dateTo;
        }
        if (this.$store.state.employees.checkTo) {
          payload.haNoEx = this.$store.state.employees.checkTo;
        }
      } else {
        payload = {
          from: this.$store.state.employees.dateFrom,
          fromOld: this.editItems.from,
          nameId: this.data.nameId,
          value: this.data.value,
          to: this.$store.state.employees.dateTo,
          initialDay: this.data.initialDay,
          initialSegment: this.data.initialSegment,
          sequenceNumber: this.data.sequenceNumber,
          haNoEx: this.$store.state.employees.checkTo,
          defaultGrp: this.data.defaultGrp == true ? "S" : "N",
        };
      }
      if (valid) {
        this.edit(payload);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    edit(payload) {
      let itemsEdit;
      switch (this.action[4]) {
        case "Grupos":
          this.seeAction = "group";
          this.$store.commit("changeGroup/setEditItems", payload);
          this.$store
            .dispatch("changeGroup/edit")
            .then(() => {
              this.$store.dispatch("changeGroup/getGroupsAssigned");
              this.ok = true;
              this.textAlertOk = "Se edito correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Pautas":
          let pattern = this.patternFunction(this.data.pattern);
          changeTimePattern.commit("setEditItems", pattern);
          changeTimePattern
            .dispatch("edit")
            .then(() => {
              changeTimePattern.dispatch("getTimePattern");
              this.ok = true;
              this.textAlertOk = "Se edito correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Horarios":
          this.seeAction = "schedules";
          itemsEdit = {
            fromOld: payload.fromOld,
            to: payload.to,
            from: payload.from,
            nameId: payload.nameId,
            initialSegment: payload.initialSegment,
            sequenceNumber: payload.sequenceNumber,
            haNoEx: payload.haNoEx,
          };

          if (typeof payload.initialDay === "string") {
            itemsEdit.initialDay = Number(payload.initialDay);
          } else {
            itemsEdit.initialDay = payload.initialDay;
          }

          this.$store.commit("changeSchedule/setEdit", itemsEdit);
          this.$store
            .dispatch("changeSchedule/edit")
            .then(() => {
              this.$store.dispatch("changeSchedule/getEmployedSchedule");
              this.ok = true;
              this.textAlertOk = "Se edito correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Modelos":
          this.seeAction = "models";
          itemsEdit = {
            date: moment().format("YYYY-MM-DD"),
            fromOld: payload.fromOld,
            to: payload.to,
            from: payload.from,
            nameId: payload.nameId,
            haNoEx: payload.haNoEx,
          };

          this.$store.commit("changeSettlementModel/setEditModel", itemsEdit);
          this.$store
            .dispatch("changeSettlementModel/editModel")
            .then(() => {
              setTimeout(() => {
                this.$store.dispatch("changeSettlementModel/getModelEmployed");
                this.ok = true;
                this.textAlertOk = "Se edito correctamente";
              }, 1500);
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Atributos":
          let atribute = this.$store.state.atributes.allAtributes.find(
            (item) => {
              return item.atribId == this.data.nameId;
            },
          );
          this.seeAction = "atributes";
          this.$store.dispatch("atributes/getAllAtributes");
          itemsEdit = {
            nameId: payload.nameId,
            name: atribute.name,
            value: payload.value,
          };

          this.$store.commit("atributes/setEdit", itemsEdit);
          this.$store
            .dispatch("atributes/edit")
            .then(() => {
              this.$store.dispatch("atributes/getAtributes");
              this.ok = true;
              this.textAlertOk = "Se edito correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });

          break;
        case "Tarjetas":
          this.seeAction = "cards";
          itemsEdit = {
            originFrom: payload.fromOld,
            to: payload.to,
            from: payload.from,
            cardId: payload.nameId,
            haNoEx: payload.haNoEx,
          };

          this.$store.commit("assignCards/setEdit", itemsEdit);
          this.$store
            .dispatch("assignCards/edit")
            .then(() => {
              this.$store.dispatch("assignCards/getCards");
              this.ok = true;
              this.textAlertOk = "Se edito correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });
          break;
        case "Saldos":
          this.seeAction = "accountBalances";
          itemsEdit = {
            amount: payload.amount,
            conceptId: payload.conceptId,
          };

          this.$store.commit("accountBalances/setEdit", itemsEdit);
          this.$store
            .dispatch("accountBalances/edit")
            .then(() => {
              this.$store.dispatch("accountBalances/getAccountBalances");
              this.ok = true;
              this.textAlertOk = "Se edito correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });
          break;
        case "Relojes":
          this.seeAction = "assignWatches";
          this.$store.commit("assignWatches/setEdit", payload);
          this.$store
            .dispatch("assignWatches/editWatch")
            .then(() => {
              this.ok = true;
              this.textAlertOk = "Se edito correctamente";
            })
            .catch((e) => {
              this.errorAlert = true;
              this.textAlertOk = e.response.data.error.message;
            });
          break;
        default:
          break;
      }
      this.showAdd = false;
      this.defaultData();
    },

    changeSchedule() {
      this.$store.commit("changeSchedule/setScheduleId", this.data.nameId);
      this.$store.dispatch("changeSchedule/getSegment");
    },

    changeSegment() {
      this.$store.commit("changeSchedule/setSegmId", this.data.initialSegment);
      this.$store.dispatch("changeSchedule/getSequence").then(() => {
        this.data.sequenceNumber =
          this.$store.state.changeSchedule.numsequence[0].id;
        this.initialDay = this.initialDays(this.data.initialSegment);
      });
    },

    initialDays(selectedData) {
      let inicialDay = this.$store.state.changeSchedule.segment.filter(
        (option) => {
          return option.segmId == selectedData;
        },
      );
      if (inicialDay.length == 1) {
        this.data.initialDay = 1;
      }
      return inicialDay[0]?.days;
    },

    patternFunction(pattern) {
      const selectedValues = pattern;

      let result = [];
      this.pattern.forEach((element) => {
        let selected = false;

        for (let i = 0; i < selectedValues.length; i++) {
          if (
            element.id === selectedValues[i] ||
            element.id === selectedValues[i]?.id
          ) {
            selected = true;
          }
        }

        result.push({
          name: element.name,
          id: element.id,
          selected: selected ? "S" : "N",
        });
      });

      let payload = {
        fromOld: this.editItems.from,
        from: this.$store.state.employees.dateFrom,
        to: this.$store.state.employees.dateTo,
        date: moment().format("YYYY-MM-DD"),
        tolerance: this.data.tolerance,
        cost: this.data.cost,
        autoriz: this.data.autoriz,
        pattern: this.data.pattern,
        haNoEx: this.$store.state.employees.checkTo,
      };
      for (let i = 0; i < result.length; i++) {
        switch (result[i].id) {
          case 0:
            payload["liqHoras"] = result[i].selected;
            break;
          case 1:
            payload["tarde"] = result[i].selected;
            break;
          case 2:
            payload["retAnt"] = result[i].selected;
            break;
          case 3:
            payload["licPar"] = result[i].selected;
            break;
          case 4:
            payload["licTot"] = result[i].selected;
            break;
          case 5:
            payload["caidas"] = result[i].selected;
            break;
          default:
            break;
        }
      }

      return payload;
    },
    cancel() {
      if (!this.titleForm) {
        this.$refs.form.resetValidation();
        this.defaultData();
      }
      this.showAdd = false;
    },
    cancelMovements() {
      if (!this.titleForm) {
        this.dataAddMovim = {
          conceptId: null,
          amount: null,
        };
      }
      this.$refs.autocomplete.resetValidation();
      this.$refs.amount.resetValidation();
      this.showBalances = false;
    },
    defaultData() {
      if (!this.titleForm) {
        this.data = {
          from: null,
          to: null,
          nameId: null,
          value: null,
          initialSegment: null,
          initialDay: null,
          sequenceNumber: null,
          pattern: [0, 1, 2, 3, 4, 5],
          tolerance: 0,
          cost: null,
          autoriz: "D",
        };
      }
      this.ok = false;
      this.errorAlert = false;
      this.checkTo = true;
      const day = moment().format("YYYY-MM-DD");
      this.$store.commit("employees/setDateTo", null);
      this.$store.commit("employees/setDateFrom", day);
      this.$store.commit("employees/setCheckTo", this.checkTo);
    },
  },
};
</script>

<style scoped>
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.card__title {
  display: flex;
  justify-content: center;
}

.container__button__dialog {
  display: flex !important;
  justify-content: flex-end !important;
}

.input__name {
  margin-left: 25px !important;
  margin-right: 25px !important;
  margin-top: 0;
  margin-bottom: -9px;
}

.title-class {
  color: #586271;
  font-weight: lighter !important;
  font-size: 15px !important;
  text-transform: capitalize !important;
  text-shadow: 1px 1px #384b6d;
}

.btn-girado {
  transform: rotate(90deg);
}
.column-menu {
  border: 1px solid #ccc;
  overflow-y: auto;
  position: relative;
  border-radius: 5px;
  overflow-x: hidden;
}
.ag-theme-quartz {
  --ag-header-height: 30px;
  --ag-header-foreground-color: white;
  --ag-header-background-color: #82a1d0;
  --ag-header-cell-hover-background-color: #7292c1;
  --ag-header-cell-moving-background-color: #7292c1;
  --ag-border-color: #82a1d0;
}
.ag-theme-quartz .ag-header {
  font-family: cursive;
}
.ag-theme-quartz .ag-header-group-cell {
  font-weight: normal;
  font-size: 22px;
}
.ag-theme-quartz .ag-header-cell {
  font-size: 18px;
}

.search {
  max-width: 500px;
}

.v-input__slot > .v-input__append-icon > .v-icon:nth-child(2) {
  display: none;
}
</style>
